// utils/websocket.js
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

let stompClient = null;
let reconnectTimer = null;
const RETRY_INTERVAL = 5000; // 重连间隔5秒

/**
 * 连接WebSocket
 * @param {string} topic 订阅的消息主题
 * @param {Function} onMessageCallback 收到消息时的回调函数
 * @param {Function} refreshCallback 连接成功后的回调（如刷新列表）
 */
export function connectWebSocket(topic, onMessageCallback, refreshCallback) {
  // const socket = new SockJS('https://localhost:8083/ws-notification');
  const socket = new SockJS('https://www.gzfmh.com/storeadmin/ws-notification');
  stompClient = Stomp.over(socket);

  stompClient.connect({},
    // 连接成功回调
    () => {
      console.log('WebSocket连接成功');
      if (reconnectTimer) clearTimeout(reconnectTimer);

      // 订阅指定的主题
      stompClient.subscribe(topic, (message) => {
        onMessageCallback(message.body);
        refreshCallback?.(); // 可选：收到消息后触发数据刷新
      });

      refreshCallback?.(); // 连接成功时也刷新一次数据
    },
    // 连接失败回调
    (error) => {
      console.error('WebSocket连接失败，尝试重连...', error);
      scheduleReconnect(topic, onMessageCallback, refreshCallback);
    }
  );
}

// 安排定时重连
function scheduleReconnect(topic, onMessageCallback, refreshCallback) {
  if (reconnectTimer) clearTimeout(reconnectTimer);
  reconnectTimer = setTimeout(() => {
    connectWebSocket(topic, onMessageCallback, refreshCallback);
  }, RETRY_INTERVAL);
}

// 断开连接
export function disconnectWebSocket() {
  if (stompClient) {
    stompClient.disconnect();
    console.log('WebSocket连接已断开');
  }
  if (reconnectTimer) clearTimeout(reconnectTimer);
}